export const MINDTAP_MAX_KEYS = 10;
export const MINDTAP_KEY_FIELD_MAX = 120;

export type MindtapReleaseKeyRow = {
  name: string;
  courseKey: string;
};

export function validateMindtapReleaseRows(rows: MindtapReleaseKeyRow[]): string | null {
  const completeRows = rows.filter(
    (row) => row.name.trim().length > 0 || row.courseKey.trim().length > 0,
  );

  if (completeRows.length < 1) {
    return "Add at least one MindTap name and course key pair.";
  }

  if (completeRows.length > MINDTAP_MAX_KEYS) {
    return `You can release at most ${MINDTAP_MAX_KEYS} keys.`;
  }

  const seenNames = new Set<string>();
  for (const row of completeRows) {
    const name = row.name.trim();
    const courseKey = row.courseKey.trim();

    if (!name || !courseKey) {
      return "Each row must include both a MindTap name and course key, or be removed.";
    }

    if (name.length > MINDTAP_KEY_FIELD_MAX) {
      return `MindTap names must be at most ${MINDTAP_KEY_FIELD_MAX} characters.`;
    }

    if (courseKey.length > MINDTAP_KEY_FIELD_MAX) {
      return `Course keys must be at most ${MINDTAP_KEY_FIELD_MAX} characters.`;
    }

    const normalized = name.toLowerCase();
    if (seenNames.has(normalized)) {
      return "Duplicate MindTap names are not allowed.";
    }
    seenNames.add(normalized);
  }

  const hasPartialRow = rows.some((row) => {
    const hasName = row.name.trim().length > 0;
    const hasKey = row.courseKey.trim().length > 0;
    return hasName !== hasKey;
  });
  if (hasPartialRow) {
    return "Complete or remove any partially filled rows before releasing.";
  }

  return null;
}

export function normalizeMindtapReleaseRows(rows: MindtapReleaseKeyRow[]): MindtapReleaseKeyRow[] {
  return rows
    .filter((row) => row.name.trim().length > 0 || row.courseKey.trim().length > 0)
    .map((row) => ({
      name: row.name.trim(),
      courseKey: row.courseKey.trim(),
    }));
}
